import ActionTypes from './../common/ActionTypes';

function clearStore() {
  return {
    type: ActionTypes.CLEAR_ALL,
  };
}

export const commonActions = {
  clearStore,
};



// WEBPACK FOOTER //
// ./src/actions/common.js